module.exports = __webpack_public_path__ + "ffc34aead58a24e926fd9e7c23489106.png";